'use client';

import { Info } from 'lucide-react';

const DOCS_BASE = 'https://sigalmark.github.io/docs';

interface TutorialLinkProps {
  href: string;
  label?: string;
}

export default function TutorialLink({ href, label }: TutorialLinkProps) {
  const fullUrl = href.startsWith('http') ? href : `${DOCS_BASE}/${href}`;

  return (
    <a
      href={fullUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-1 text-xs transition-colors group"
      title={label || 'Open tutorial'}
    >
      <Info className="size-5 text-[#1a5632] group-hover:text-[#14432a] transition-colors" />
      {label && <span className="text-muted-foreground group-hover:text-primary">{label}</span>}
    </a>
  );
}
